/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Error 520
 * @export
 * @interface PostCharactersCharacterIdMailError520
 */
export interface PostCharactersCharacterIdMailError520 {
    /**
     * Error 520 message
     * @type {string}
     * @memberof PostCharactersCharacterIdMailError520
     */
    error?: string;
}

/**
 * Check if a given object implements the PostCharactersCharacterIdMailError520 interface.
 */
export function instanceOfPostCharactersCharacterIdMailError520(value: object): value is PostCharactersCharacterIdMailError520 {
    return true;
}

export function PostCharactersCharacterIdMailError520FromJSON(json: any): PostCharactersCharacterIdMailError520 {
    return PostCharactersCharacterIdMailError520FromJSONTyped(json, false);
}

export function PostCharactersCharacterIdMailError520FromJSONTyped(json: any, ignoreDiscriminator: boolean): PostCharactersCharacterIdMailError520 {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function PostCharactersCharacterIdMailError520ToJSON(json: any): PostCharactersCharacterIdMailError520 {
    return PostCharactersCharacterIdMailError520ToJSONTyped(json, false);
}

export function PostCharactersCharacterIdMailError520ToJSONTyped(value?: PostCharactersCharacterIdMailError520 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

